/**
 * Disease- and trait-related constants for the disease/trait portal.
 */

export const diseaseCT = {
  ASD: [
    { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
    //{ val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
    { val: "Endo", cardLabel: "Endothelial cells", cardDesc: "" },
    { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pax6", cardLabel: "PAX6-expressing Inhibitory Neurons", cardDesc: "" },
    
    { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
    { val: "Micro", cardLabel: "Microglia", cardDesc: "" },
    // { val: "Lamp5.Lhx6", cardLabel: "Lamp5.Lhx6", cardDesc: "" },
    { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  
    // { val: "L6b", cardLabel: "L6b", cardDesc: "" },
    {
      val: "L6.IT",
      cardLabel: "Layer 6 Intratelencephalic Projecting",
      cardDesc: "",
    },
    /*{
        val: "L6.IT.Car3",
        cardLabel: "Layer 6 Intratelencephalic projecting Car3",
        cardDesc: "",
      },*/
    {
      val: "L6.CT",
      cardLabel: "Layer 6 Corticothalamic Projecting",
      cardDesc: "",
    },
    {
      val: "L5.IT",
      cardLabel: "Layer 5 Intratelencephalic Projecting",
      cardDesc: "",
    },
    //{ val: "L5.6.NP", cardLabel: "Layer 5/6 Near projecting", cardDesc: "" },
    {
      val: "L4.IT",
      cardLabel: "Layer 4 Intratelencephalic Projecting",
      cardDesc: "",
    },
    {
      val: "L2.3.IT",
      cardLabel: "Layer 2/3 Intratelencephalic Projecting",
      cardDesc: "",
    },
  ],

  Age: [
    { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
    { val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
    //{ val: "Pax6", cardLabel: "Pax6", cardDesc: "" },
    { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  
    { val: "Oligo", cardLabel: "Oligodendrocytes", cardDesc: "" },
    { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
    { val: "Micro", cardLabel: "Microglia", cardDesc: "" },
    { val: "Lamp5.Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
    {
      val: "L6.IT",
      cardLabel: "Layer 6 Intratelencephalic projecting",
      cardDesc: "",
    },
    {
      val: "L6.IT.Car3",
      cardLabel: "Layer 6 Intratelencephalic projecting Car3",
      cardDesc: "",
    },
    {
      val: "L6.CT",
      cardLabel: "Layer 6 Corticothalamic projecting",
      cardDesc: "",
    },
    {
      val: "L5.IT",
      cardLabel: "Layer 5 Intratelencephalic projecting",
      cardDesc: "",
    },
    { val: "L5.6.NP", cardLabel: "Layer 5/6 Near projecting", cardDesc: "" },
    {
      val: "L4.IT",
      cardLabel: "Layer 4 Intratelencephalic projecting",
      cardDesc: "",
    },
    {
      val: "L2.3.IT",
      cardLabel: "Layer 2/3 Intratelencephalic projecting",
      cardDesc: "",
    },
  ],
  Bipolar_Disorder: [
    { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
    { val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
    { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  
    { val: "Oligo", cardLabel: "Oligodendrocytes", cardDesc: "" },
    { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
    { val: "Micro", cardLabel: "Microglia", cardDesc: "" },
    { val: "Lamp5.Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
    {
      val: "L6.IT",
      cardLabel: "Layer 6 Intratelencephalic projecting",
      cardDesc: "",
    },
    {
      val: "L6.IT.Car3",
      cardLabel: "Layer 6 Intratelencephalic projecting Car3",
      cardDesc: "",
    },
    {
      val: "L6.CT",
      cardLabel: "Layer 6 Corticothalamic projecting",
      cardDesc: "",
    },
    {
      val: "L5.IT",
      cardLabel: "Layer 5 Intratelencephalic projecting",
      cardDesc: "",
    },
    { val: "L5.6.NP", cardLabel: "Layer 5/6 Near projecting", cardDesc: "" },
    {
      val: "L4.IT",
      cardLabel: "Layer 4 Intratelencephalic projecting",
      cardDesc: "",
    },
    {
      val: "L2.3.IT",
      cardLabel: "Layer 2/3 Intratelencephalic projecting",
      cardDesc: "",
    },
  ],

  Schizophrenia: [
    { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
    { val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
    { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  
    { val: "Oligo", cardLabel: "Oligodendrocytes", cardDesc: "" },
    { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
    { val: "Micro", cardLabel: "Microglia", cardDesc: "" },
    { val: "Lamp5.Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
    { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
    {
      val: "L6.IT",
      cardLabel: "Layer 6 Intratelencephalic Projecting",
      cardDesc: "",
    },
    {
      val: "L6.IT.Car3",
      cardLabel: "Layer 6 Intratelencephalic Projecting Car3",
      cardDesc: "",
    },
    {
      val: "L6.CT",
      cardLabel: "Layer 6 Corticothalamic Projecting",
      cardDesc: "",
    },
    {
      val: "L5.IT",
      cardLabel: "Layer 5 Intratelencephalic Projecting",
      cardDesc: "",
    },
    { val: "L5.6.NP", cardLabel: "Layer 5/6 Near Projecting", cardDesc: "" },
    {
      val: "L4.IT",
      cardLabel: "Layer 4 Intratelencephalic Projecting",
      cardDesc: "",
    },
    {
      val: "L2.3.IT",
      cardLabel: "Layer 2/3 Intratelencephalic Projecting",
      cardDesc: "",
    },
  ],
};

export const CELLTYPE_CARDS = [
  { val: "Ast", cardLabel: "Astrocytes", cardDesc: "" },
  { val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
  { val: "End", cardLabel: "Endothelial cells", cardDesc: "" },
  { val: "Immune", cardLabel: "Immune Cells", cardDesc: "" },
  { val: "VLMC", cardLabel: "Vascular Leptomeningeal Cells", cardDesc: "" },
  { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pax6", cardLabel: "PAX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Oli", cardLabel: "Oligodendrocytes", cardDesc: "" },
  { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
  { val: "Mic", cardLabel: "Microglia", cardDesc: "" },
  { val: "Lamp5.Lhx6", cardLabel: "LAMP5 or LHX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
  {
    val: "L6.IT",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L6.IT.Car3",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons Expressing Car3",
    cardDesc: "",
  },
  {
    val: "L6.CT",
    cardLabel: "Layer 6 Corticothalamic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5.IT",
    cardLabel: "Layer 5 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5.ET",
    cardLabel: "Layer 5 Extratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  { val: "L5.6.NP", cardLabel: "Layer 5 or 6 Near Projecting Excitatory Neurons", cardDesc: "" },
  {
    val: "L4.IT",
    cardLabel: "Layer 4 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L2.3.IT",
    cardLabel: "Layer 2 or 3 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  { val: "PC", cardLabel: "Pericytes", cardDesc: "" },
];

export const GENE_CELLTYPE_CARDS = [
  { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
  { val: "Chandelier", cardLabel: "Chandelier Inhibitory Neurons", cardDesc: "" },
  { val: "SMC", cardLabel: "Smooth Muscle Cells", cardDesc: "" },
  { val: "Endo", cardLabel: "Endothelial Cells", cardDesc: "" },
  { val: "Misc", cardLabel: "Vasculature-related Cells", cardDesc: "" },
  { val: "OPCs", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
  { val: "InhibitoryNeurons", cardLabel: "Inhibitory Neurons", cardDesc: "" },
  { val: "ExcitatoryNeurons", cardLabel: "Excitatory Neurons", cardDesc: "" },
  { val: "Immune", cardLabel: "Immune Cells", cardDesc: "" },
  { val: "VLMC", cardLabel: "Vascular Leptomeningeal Cells", cardDesc: "" },
  { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pax6", cardLabel: "PAX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Oligo", cardLabel: "Oligodendrocytes", cardDesc: "" },
  { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
  { val: "Micro", cardLabel: "Microglia", cardDesc: "" },
  { val: "Sst Chodl", cardLabel: "SST/CHODL-expressing Inhibitory Neurons", cardDesc: "" },
  
  { val: "Lamp5 Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
  {
    val: "L6 IT",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L6 IT Car3",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons Expressing Car3",
    cardDesc: "",
  },
  {
    val: "L6 CT",
    cardLabel: "Layer 6 Corticothalamic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5 IT",
    cardLabel: "Layer 5 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5 ET",
    cardLabel: "Layer 5 Extratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  { val: "L5/6 NP", cardLabel: "Layer 5 or 6 Near Projecting Excitatory Neurons", cardDesc: "" },
  {
    val: "L4 IT",
    cardLabel: "Layer 4 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L2/3 IT",
    cardLabel: "Layer 2 or 3 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  { val: "PC", cardLabel: "Pericytes", cardDesc: "" },
];

export const GRN_cellType_Cards = [
  { val: "Ast", cardLabel: "Astrocytes", cardDesc: "" },
  { val: "Chandelier", cardLabel: "Chandelier", cardDesc: "" },
  { val: "End", cardLabel: "Endothelial cells", cardDesc: "" },
  { val: "Immune", cardLabel: "Immune Cells", cardDesc: "" },
  { val: "VLMC", cardLabel: "Vascular Leptomeningeal Cells", cardDesc: "" },
  { val: "Sncg", cardLabel: "SNCG-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Vip", cardLabel: "VIP-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Sst", cardLabel: "SST-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pvalb", cardLabel: "PVALB-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Pax6", cardLabel: "PAX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Oli", cardLabel: "Oligodendrocytes", cardDesc: "" },
  { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
  { val: "Mic", cardLabel: "Microglia", cardDesc: "" },
  { val: "Lamp5.Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
  
  {
    val: "L6.IT",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L6.IT.Car3",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons Expressing Car3",
    cardDesc: "",
  },
  {
    val: "L6.CT",
    cardLabel: "Layer 6 Corticothalamic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5.IT",
    cardLabel: "Layer 5 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5.ET",
    cardLabel: "Layer 5 Extratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  { val: "L5.6.NP", cardLabel: "Layer 5/6 Near Projecting Excitatory Neurons", cardDesc: "" },
  {
    val: "L4.IT",
    cardLabel: "Layer 4 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L2.3.IT",
    cardLabel: "Layer 2/3 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
];
export const Qtl_Celltype_Cards = [
  { val: "Astro", cardLabel: "Astrocytes", cardDesc: "" },
  { val: "Chandelier__Pvalb", cardLabel: "Chandelier", cardDesc: "" },
  { val: "Vip", cardLabel: "Vip", cardDesc: "" },
  { val: "Sst__Sst.Chodl", cardLabel: "Sst", cardDesc: "" },
  { val: "PC", cardLabel: "Pericytes", cardDesc: "" },
  //  {val: "Pax6", cardLabel: "Pax6", cardDesc: ""},
  { val: "Oligo", cardLabel: "Oligodendrocytes", cardDesc: "" },
  { val: "OPC", cardLabel: "Oligodendrocyte Precursor Cells", cardDesc: "" },
  { val: "Micro.PVM", cardLabel: "Microglia", cardDesc: "" },
  { val: "Lamp5.Lhx6", cardLabel: "LAMP5/LHX6-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "Lamp5", cardLabel: "LAMP5-expressing Inhibitory Neurons", cardDesc: "" },
  { val: "L6b", cardLabel: "Layer 6b Excitatory Neurons", cardDesc: "" },
  
  {
    val: "L6.IT",
    cardLabel: "Layer 6 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  //  {val: "L6.IT.Car3", cardLabel: "Layer 6 Intratelencephalic projecting Car3", cardDesc: ""},
  {
    val: "L6.CT",
    cardLabel: "Layer 6 Corticothalamic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L5.IT",
    cardLabel: "Layer 5 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  //  { val: "L5.ET", cardLabel: "Layer 5 Extratelencephalic projecting", cardDesc: ""},
  { val: "L5.6.NP", cardLabel: "Layer 5/6 Near Projecting Excitatory Neurons", cardDesc: "" },
  {
    val: "L4.IT",
    cardLabel: "Layer 4 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
  {
    val: "L2.3.IT",
    cardLabel: "Layer 2/3 Intratelencephalic Projecting Excitatory Neurons",
    cardDesc: "",
  },
];
